import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "./App.css";
import { additionalEnglishContent, additionalGujratiContent, additionalHindiContent, additionalKannadaContent, additionalPunjabiContent, additionalTeleguContent, additionalTamilContent} from "./Common/AdditionalContent";
import {
  EnglishLanguageContent,
  GujratiLanguageContent,
  HindiLanguageContent,
  KannadaLanguageContent,
  PunjabiLanguageContent,
  TeluguLanguageContent,
  MarathiLanguageContent,
  TamilLanguageContent
} from "./Common/Language";
import Header from "./components/Header";
import LoaderComp from "./LoaderComp";
import Home from "./pages/Home";

import InformationPage from "./pages/Information/InformationPage";
import HdfcScripts from "./pages/HdfcScripts/HdfcScripts";
import CallDisconnected from "./pages/CallDisconnected/CallDisconnected";
import PersonalDetails from "./pages/PersonalDetails/PersonalDetails";
import PersonalDisagreement from "./pages/PersonalDetails/PersonalDisagreement";
import PolicyDetails from "./pages/PolicyDetails/PolicyDetails";
import PolicyDisagreement from "./pages/PolicyDetails/PolicyDisagreement";
import FetchError from "./pages/SorryPage/FetchError";
import SorryPage from "./pages/SorryPage/SorryPage";
import SorryPageAttempt from "./pages/SorryPage/SorryPageAttempt";
import SorryPageComplete from "./pages/SorryPage/SorryPageComplete";
import FlowCompleteTY from "./pages/ThankYou/FlowCompleteTY";
import ThankYou from "./pages/ThankYou/ThankYou";
import Otp from "./pages/Verification/Otp";
import VerificationPage from "./pages/Verification/VerificationPage";
import VideoPage from "./pages/VideoPage/VideoPage";
import { addCallId, addToUser } from "./Redux/UserSlice";
import { getNameApi, getUser } from "./services/service";

function App() {
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({});
  const [page, setPage] = useState();
  const [languageContent, setLanguageContent] = useState({});
  const [additionalContent, setAdditionalContent] = useState({});
  const getName = async (callId) => {
    let fetchdata = {};
    await getNameApi(callId)
      .then(async (data) => {
        fetchdata = data.data;
        console.log(data.data);
        setUserData(data.data);
        if (
          fetchdata.language.toLowerCase() === "en" ||
          fetchdata.language.toLowerCase() === "english"
        ) {
          let res = EnglishLanguageContent;
          let additional = additionalEnglishContent;
          setLanguageContent(res);
          setAdditionalContent(additional);
        } else if(fetchdata.language.toLowerCase() === "pun"){
          let res = PunjabiLanguageContent;
          let additional = additionalPunjabiContent;
          setLanguageContent(res);
          setAdditionalContent(additional);
        }else if(fetchdata.language.toLowerCase() === "ta"){
          let res = TamilLanguageContent;
          let additional = additionalTamilContent;
          setLanguageContent(res);
          setAdditionalContent(additional);
        }
        
        else if(fetchdata.language.toLowerCase() === "gj"){
          let res = GujratiLanguageContent;
          let additional = additionalGujratiContent;
          setLanguageContent(res);
          setAdditionalContent(additional);
        }
        else if(fetchdata.language.toLowerCase() === "te"){
          let res = TeluguLanguageContent;
          let additional = additionalTeleguContent;
          setLanguageContent(res);
          setAdditionalContent(additional);
        }
        else if(fetchdata.language.toLowerCase() === "ka"){
          let res = KannadaLanguageContent;
          let additional = additionalKannadaContent;
          setLanguageContent(res);
          setAdditionalContent(additional);
        }
        else if(fetchdata.language.toLowerCase() === "mr"){
          let res = MarathiLanguageContent;
          let additional = additionalEnglishContent;
          setLanguageContent(res);
          setAdditionalContent(additional);
        }
       
        else {
          let res = HindiLanguageContent;
          let additional = additionalHindiContent;
          setLanguageContent(res);
          setAdditionalContent(additional);
        }
        if (fetchdata.status === "COMPLETED") {
          console.log("sorryComplete");
          setPage("sorryPageComplete");
        } else {
          // if(data?.data?.flow_type?.toLowerCase() === "hdfc"){
            setPage("verification");
          // }
          // else{
          //   await getUser(callId)
          //     .then((res) => {
                // setPage("information")
          //       dispatch(addToUser(res.data));
          //     })
          //     .catch(err => {
          //       setPage("fetchError");
          //     })
          // }
        }
      })
      .catch((e) => {
        setPage("fetchError");
        console.log(e.message);
      });
  };
  const getCallId = (val) => {
    console.log(val);
    dispatch(addCallId(val));
    // dispatch(addCallId("19aab221-a8e6-4556-950c-000b86e7ec18"));
  };

  useEffect(() => {
    let call_id = window.location.search.split("=")[1];

    getName(call_id);
    getCallId(call_id);


  }, []);

  const SwitchComp = (page) => {
    switch (page) {
      case "sorryPageComplete":
        return (
          <SorryPageComplete
            setPage={setPage}
            languageContent={languageContent}
          />
        );
      case "landing":
        return (
          <Home
            setPage={setPage}
            languageContent={languageContent}
            userData={userData}
          />
        );
      case "verification":
        return (
          <VerificationPage
            setPage={setPage}
            languageContent={languageContent}
            userData={userData}
          />
        );
      case "otp":
        return <Otp setPage={setPage} languageContent={languageContent} userData={userData} />;
      case "personalDetails":
        return (
          <PersonalDetails
            setPage={setPage}
            languageContent={languageContent}
            userData={userData}
          />
        );
      case "personalDetailDisagree":
        return (
          <PersonalDisagreement
            setPage={setPage}
            languageContent={languageContent}
            additionalContent={additionalContent}
            userData={userData}
          />
        );
      case "policyDetails":
        return (
          <PolicyDetails
            setPage={setPage}
            languageContent={languageContent}
            additionalContent={additionalContent}
            userData={userData}
          />
        );
      case "policyDetailsDisagree":
        return (
          <PolicyDisagreement
            setPage={setPage}
            languageContent={languageContent}
            additionalContent={additionalContent}
            userData={userData}
          />
        );
      case "hdfcScripts":
        return (
          <HdfcScripts
            setPage={setPage}
            languageContent={languageContent}
            additionalContent={additionalContent}
            userData={userData}
          />
        );
      case "information":
        return (
          <InformationPage
            setPage={setPage}
            languageContent={languageContent}
            userData={userData}
          />
        );
        case "callDisconnected":
        return (
          <CallDisconnected
            setPage={setPage}
            languageContent={languageContent}
            userData = {userData}
          />
        );
      case "video":
        return (
          <VideoPage setPage={setPage} languageContent={languageContent} />
        );
      case "thankYou":
        return <ThankYou setPage={setPage} languageContent={languageContent} />;
      case "thankYouComplete":
        return <FlowCompleteTY languageContent={languageContent} />;
      case "sorryPage":
        return (
          <SorryPage setPage={setPage} languageContent={languageContent} />
        );
      case "fetchError":
        return (
          <FetchError setPage={setPage} languageContent={languageContent} />
        );
      case "sorryPageAttempt":
        return (
          <SorryPageAttempt
            setPage={setPage}
            languageContent={languageContent}
          />
        );
    }
  };

  return (
    <>
      <div className="container">
        <div className="main-page">
          <Header />
          <div className="container-mainCard">
            {Object.values(userData).length > 0 ? (
              <>
                <div className="mainCard">{SwitchComp(page)}</div>
              </>
            ) : (
              <div className="mainCard">
                {page === "fetchError" ? <p>Network Error</p> : <LoaderComp />}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
